export const GET_PRESET_LIST = 'GET_PRESET_LIST'
export const PRESET_BOX_SUCCESS = 'PRESET_BOX_SUCCESS'
export const PRESET_BOX_ERROR = 'PRESET_BOX_ERROR'